import styled from 'styled-components';
import { PUBLIC_URL } from '../../../../config';

export const MobileWelcomeBannerStyled = styled.div`
    .mobile-bonus-banner {
        > div {
            background-position: right bottom;
            background-size: 350px;
            background-repeat: no-repeat;
            background-image: url(${PUBLIC_URL + '/assets/bonus/bonus-welcome-half.png'});
        }
    }
    
    &.full-amount {
        .mobile-bonus-banner {
            background: linear-gradient(270.98deg, #FEFA7B 1.23%, #FFE35F 100%);
            > div {
                background-image: url(${PUBLIC_URL + '/assets/bonus/bonus-welcome-full.png'});
            }
        }
    }
    
    &.short {
        .mobile-bonus-banner {
            > div {
                background-position: right center;
            }
        }
    }
`;

export const MobileWelcomeBonusBannerTopUpButtonStyled = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 8px;
    color: var(--color-black);
    
    svg {
        fill: var(--color-black);
    }
`;
